export default {"src":"/_next/static/media/metal-titanium.da4783d3.svg","height":27,"width":32};